module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div class=\"prop-header\"><span class=\"prop-label\">Filter</span></div>\r\n\r\n<div class=\"row\">\r\n    <div class=\"col-md-1\"><input type=\"checkbox\" name=\"additiveDynamicFilter\"></div>\r\n    <div class=\"col-md-8\" style=\"margin-top: 3px;\"><span>Override previous filter</span></div>\r\n</div>")
  }
  return __output;

}